export const newChecklist = {
  id: null,
  title: "",
  tasks: [
    {
      id: 1,
      title: "",
      body: "",
      categoryId: "",
      completed: false,
      timeOfCompletion: null
    },
    {
      id: 2,
      title: "",
      body: "",
      categoryId: "",
      completed: false,
      timeOfCompletion: null
    }
  ]
};

export const newTask = {
  id: null,
  title: "",
  body: "",
  category: "",
  completed: false,
  timeOfCompletion: null
};

export default newChecklist;
